// Query Params
export const SET_QUERY_PARAMS = 'SET_QUERY_PARAMS';
export const ADD_QUERY_PARAMS = 'ADD_QUERY_PARAMS';



// WEBPACK FOOTER //
// ./src/store/reducers/queryParams/actionTypes.js